/**
 * VK Next — feature pack for VKontakte
 *
 * Declares one web-accessible-resource entry (several globs plus the concrete
 * `mitm.html`, `popup.html` and `mitmWorker.js`) matched to VK's own origins —
 * `vk.com`, `vk.ru`, `vkvideo.ru` and related — with no `use_dynamic_url`. The
 * named files are static, so they are fetchable at a fixed URL, but only from
 * those VK origins; no other page matches the `matches` list.
 *
 * So VK Next is detectable, but only by vk.com and its siblings. Elsewhere the
 * resources are unreachable and a negative says nothing.
 *
 * Manifest verified against version 14.14.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'jephanpkonkmnkekmlkcijdjgniikppl';

export const vkNext: ExtensionDefinition = {
  id: ID,
  name: 'VK Next - функции для ВКонтакте',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  requiredOrigin: 'https://vk.com',
  notes:
    'Static WAR (mitmWorker.js, mitm.html, popup.html) scoped to VK origins. ' +
    'Only vk.com and its siblings can detect it; conclusive there.',
  signals: [
    {
      id: 'war-mitm-worker-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch mitmWorker.js — a vendor-distinctive worker script, static and exposed ' +
        'only to VK origins.',
      weight: 1,
      run: () => probeFetch(ID, 'mitmWorker.js'),
    },
    {
      id: 'war-mitm-html',
      kind: 'web-accessible-resource',
      description: 'Fetch mitm.html — a second origin-scoped static resource.',
      weight: 0.5,
      run: () => probeFetch(ID, 'mitm.html'),
    },
    {
      id: 'war-popup-html',
      kind: 'web-accessible-resource',
      description: 'Fetch popup.html — a third origin-scoped static resource.',
      weight: 0.5,
      run: () => probeFetch(ID, 'popup.html'),
    },
  ],
};
